import { useEffect, useState } from "react";
import { requester } from "api/pesabackend";
import { useSelector } from "react-redux";

const resource_tag = 'accounts';

const useGetUserList = (pageNumber, business_branch_id) => {
    const refreshCount = useSelector((state) => state.authReducer.refreshCount);
    const [userList, setUserList] = useState([]);
    const [isLoadingUserList, setLoadingUserList] = useState(true);
    const [errorUserList, setErrorUserList] = useState(false);

    const url = `/${ resource_tag }/list?business_branch=${ business_branch_id }`;

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await requester.get(url);
                setUserList(response.data.data);
                setLoadingUserList(false);
                setErrorUserList(false);
            } catch (e) {
                setErrorUserList(true);
                setLoadingUserList(false);
            }
        };
        fetchData();
    }, [pageNumber, refreshCount, url]);
    return { userList, isLoadingUserList, errorUserList };
};

export { useGetUserList }